<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="false"
    [noBow]="true"
    [title]="loaded ? clientHubInfo?.client_hub_details.team.name : ''" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper class="hasnt-top-nav">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      @if (!windowService.isDesktopRes) {
        <tidy-alert>
          <tidy-grid>
            <ion-row>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="'Welcome'" /><span>&nbsp;</span>
                    <tidy-text
                      [header]="(getClientFirstName(clientHubInfo?.client_hub_details.customer.name) | titlecase) + '!'"
                      [translate]="false" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Need help? Contact us:'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="clientHubInfo?.client_hub_details.team.owner.name + ' - ' + clientHubInfo?.client_hub_details.team.owner.email"
                      [translate]="false" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="clientHubInfo?.client_hub_details.team.owner.phone | telephone" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-grid>
          </tidy-alert>
        }
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/card.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Owed Bills'" />
          </tidy-row>
          @for (invoice of clientHubInfo?.pending_invoices | slice:0:showLimiter['pendingInvoices']; track invoice) {
            <tidy-card-button (action)="goToInvoicePage(invoice)">
              <tidy-row>
                <tidy-text
                  [body]="invoice?.amount_due | tcurrency" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'Bill'" />
                  <br>
                    @for (job of invoice?.items; track job) {
                      <tidy-text
                        [helper]="'Job on'" /><span>&nbsp;</span>
                        <tidy-text
                          [helper]="job?.service_details?.date | parseDateTime:'MMM d'" /><br>
                      }
                    </tidy-row>
                  </tidy-card-button>
                }
                @if (clientHubInfo?.pending_invoices.length >= 4) {
                  <tidy-card-button (action)="showLimit('pendingInvoices')">
                    <tidy-row>
                      @if (showLimiter['pendingInvoices'] == 3) {
                        <tidy-text
                          [body]="'Show all bills'" />
                      }
                      @if (showLimiter['pendingInvoices'] !== 3) {
                        <tidy-text
                          [body]="'Show less bills'" />
                      }
                    </tidy-row>
                  </tidy-card-button>
                }
                @if (clientHubInfo?.pending_invoices.length == 0) {
                  <tidy-row  class="extra-top-padding">
                    <tidy-text
                      [helper]="'No owed bills'" />
                  </tidy-row>
                }
              </tidy-card>
              <tidy-card>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/proposals-black.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Pending Proposals'" />
                </tidy-row>
                @for (proposal of clientHubInfo?.pending_proposals | slice:0:showLimiter['pendingProposals']; track proposal) {
                  <tidy-card-button (action)="goToPendingProposalPage(proposal)">
                    <tidy-row>
                      <tidy-text
                        [body]="proposal?.service_details?.service_name | titlecase" />
                      <br>
                        <tidy-text
                          [helper]="'Sent'" /><span>&nbsp;</span>
                          <tidy-text
                            [helper]="proposal?.created_at | parseDateTime:'MMM d':'local'" />
                        </tidy-row>
                      </tidy-card-button>
                    }
                    @if (clientHubInfo?.pending_proposals.length >= 4) {
                      <tidy-card-button (action)="showLimit('pendingProposals')">
                        <tidy-row>
                          @if (showLimiter['pendingProposals'] == 3) {
                            <tidy-text
                              [body]="'Show all proposals'" />
                          }
                          @if (showLimiter['pendingProposals'] !== 3) {
                            <tidy-text
                              [body]="'Show less proposals'" />
                          }
                        </tidy-row>
                      </tidy-card-button>
                    }
                    @if (clientHubInfo?.pending_proposals.length == 0) {
                      <tidy-row  class="extra-top-padding">
                        <tidy-text
                          [helper]="'No pending proposals'" />
                      </tidy-row>
                    }
                  </tidy-card>
                  <tidy-card>
                    <tidy-row class="vertical-align-center">
                      <tidy-image
                        [src]="'assets/svg/briefcase.svg'"
                        class="header-size" />
                      <tidy-text
                        [header]="'Accepted Proposals'" />
                    </tidy-row>
                    @for (proposal of clientHubInfo?.accepted_proposals | slice:0:showLimiter['acceptedProposals']; track proposal) {
                      <tidy-card-button (action)="goToAcceptedProposalPage(proposal)">
                        <tidy-row>
                          <tidy-text
                            [body]="proposal?.service_details?.service_name | titlecase" />
                          <br>
                            <tidy-text
                              [helper]="'Sent'" /><span>&nbsp;</span>
                              <tidy-text
                                [helper]="proposal?.created_at | parseDateTime:'MMM d':'local'" />
                            </tidy-row>
                          </tidy-card-button>
                        }
                        @if (clientHubInfo?.accepted_proposals.length >= 4) {
                          <tidy-card-button (action)="showLimit('acceptedProposals')">
                            <tidy-row>
                              @if (showLimiter['acceptedProposals'] == 3) {
                                <tidy-text
                                  [body]="'Show all proposals'" />
                              }
                              @if (showLimiter['acceptedProposals'] !== 3) {
                                <tidy-text
                                  [body]="'Show less proposals'" />
                              }
                            </tidy-row>
                          </tidy-card-button>
                        }
                        @if (clientHubInfo?.accepted_proposals.length == 0) {
                          <tidy-row  class="extra-top-padding">
                            <tidy-text
                              [helper]="'No accepted proposals'" />
                          </tidy-row>
                        }
                      </tidy-card>
                      <tidy-card>
                        <tidy-row class="vertical-align-center">
                          <tidy-image
                            [src]="'assets/svg/checkmark-circle.svg'"
                            class="header-size" />
                          <tidy-text
                            [header]="'Paid Bills'" />
                        </tidy-row>
                        @for (invoice of clientHubInfo?.paid_invoices | slice:0:showLimiter['paidInvoices']; track invoice) {
                          <tidy-card-button (action)="goToPaidInvoicePage(invoice)">
                            <tidy-row>
                              <tidy-text
                                [body]="invoice?.amount | tcurrency" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="'Receipt'" />
                                <br>
                                  <tidy-text
                                    [helper]="'Job on'" /><span>&nbsp;</span>
                                    <tidy-text
                                      [helper]="invoice?.created_at | parseDateTime:'MMM d':'local'" />
                                  </tidy-row>
                                </tidy-card-button>
                              }
                              @if (clientHubInfo?.paid_invoices.length >= 4) {
                                <tidy-card-button (action)="showLimit('paidInvoices')">
                                  <tidy-row>
                                    @if (showLimiter['paidInvoices'] == 3) {
                                      <tidy-text
                                        [body]="'Show all bills'" />
                                    }
                                    @if (showLimiter['paidInvoices'] !== 3) {
                                      <tidy-text
                                        [body]="'Show less bills'" />
                                    }
                                  </tidy-row>
                                </tidy-card-button>
                              }
                              @if (clientHubInfo?.paid_invoices.length == 0) {
                                <tidy-row  class="extra-top-padding">
                                  <tidy-text
                                    [helper]="'No paid bills'" />
                                </tidy-row>
                              }
                            </tidy-card>
                            <tidy-card>
                              <tidy-row class="vertical-align-center">
                                <tidy-image
                                  [src]="'assets/svg/calendar.svg'"
                                  class="header-size" />
                                <tidy-text
                                  [header]="'Next Job'" />
                              </tidy-row>
                              @if (clientHubInfo?.next_job?.start_date !== null) {
                                <tidy-row class="extra-top-padding">
                                  <tidy-text
                                    [body]="'Job Scheduled for'" /><span>&nbsp;</span>
                                    <tidy-text
                                      [body]="clientHubInfo?.next_job?.start_date | parseDateTime:'MMM d'" />
                                  </tidy-row>
                                }
                                @if (clientHubInfo?.next_job?.start_date === null) {
                                  <tidy-row class="extra-top-padding">
                                    <tidy-text
                                      [helper]="'No jobs scheduled'" />
                                  </tidy-row>
                                }
                              </tidy-card>
                            }

                            @if (!loaded) {
                              <tidy-alert>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 180px; height: 20px" />
                                </tidy-row>
                                <tidy-row>
                                  <ion-skeleton-text animated="true" style="width: 160px" />
                                </tidy-row>
                                <tidy-row>
                                  <ion-skeleton-text animated="true" style="width: 240px" />
                                </tidy-row>
                                <tidy-row>
                                  <ion-skeleton-text animated="true" style="width: 120px" />
                                </tidy-row>
                              </tidy-alert>
                              <tidy-card>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 150px; height: 20px" />
                                </tidy-row>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                              </tidy-card>
                              <tidy-card>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 180px; height: 20px" />
                                </tidy-row>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                              </tidy-card>
                              <tidy-card>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 190px; height: 20px" />
                                </tidy-row>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                              </tidy-card>
                              <tidy-card>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 150px; height: 20px" />
                                </tidy-row>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                                <tidy-card-button [hideArrow]="true">
                                  <tidy-row>
                                    <ion-skeleton-text animated="true" style="width: 80px" />
                                    <ion-skeleton-text animated="true" style="width: 100px" />
                                  </tidy-row>
                                </tidy-card-button>
                              </tidy-card>
                              <tidy-card>
                                <tidy-row class="vertical-align-center">
                                  <ion-skeleton-text animated="true" style="width: 130px; height: 20px" />
                                </tidy-row>
                                <tidy-row class="vertical-align-center extra-top-padding">
                                  <ion-skeleton-text animated="true" style="width: 180px" />
                                </tidy-row>
                              </tidy-card>
                            }
                          </tidy-wrapper>
                        </ng-template>

                        <ng-template #rightColumn>
                          @if (loaded) {
                            <tidy-wrapper>
                              <tidy-row [align]="'center'">
                                <tidy-text
                                  [header]="'Welcome'" /><span>&nbsp;</span>
                                  <tidy-text
                                    [header]="(getClientFirstName(clientHubInfo?.client_hub_details.customer.name) | titlecase) + '!'" />
                                </tidy-row>
                                <tidy-row [align]="'center'">
                                  <tidy-text
                                    [body]="'Need help? Contact us:'" />
                                </tidy-row>
                                <tidy-row [align]="'center'">
                                  <tidy-text
                                    [body]="clientHubInfo?.client_hub_details.team.owner.name + '<br>' + clientHubInfo?.client_hub_details.team.owner.email + '<br>' + (clientHubInfo?.client_hub_details.team.owner.phone | telephone)" />
                                </tidy-row>
                              </tidy-wrapper>
                            }
                          </ng-template>

                          <div class="wrapper-containing-block">
                            <app-scroll-wrapper [templateRightColumn]="rightColumn" [templateContent]="content" />
                          </div>

                          <app-scroll-wrapper [templateContent]="content" />
